import OkC from "shared/util/OkcApi";

const exists = function exists(el) {
	return typeof el !== "undefined" && el !== null;
};

export default {
	saveForm(params = {}) {
		const values = { ...params.values };
		const calls = [];
		const preliminaryCalls = [];

		if (!exists(values)) {
			return Promise.reject("missing params");
		}

		// strip out some shit that we don't need to send across the wire
		const paramsToDelete = [
			"params",
			"isSaving",
			"isUsernameSearching",
			"linkedAccount",
			"showPartner",
			"partnerError",
			"partner; // forever alon",
			"error",
			"displayGender",
			"displayOrientation",
			"setActiveForm",
			"cancelActiveForm",
			"saveForm",
			"usernameSearch",
			"usernameResults",
			"validUsernames",
		];

		paramsToDelete.forEach((param) => {
			delete values[param];
		});

		if (values.linked_account) {
			calls.push(OkC.post("/profile/me/link", {
				data: {
					username: values.linked_account,
				},
			}));
		}

		if (values.education && values.education.schools) {
			preliminaryCalls.push(OkC.post("/profile/me/education", {
				data: {
					educationInfo: values.education.schools,
				},
			}));
		}

		if (values.occupation) {
			preliminaryCalls.push(OkC.post("/profile/me/occupation", {
				data: {
					title: values.occupation.title,
					employer: values.occupation.employer,
				},
			}));
		}

		return Promise.all(preliminaryCalls).then(() => {
			// There's something weird going on where this promise chain doesn't actually work
			// unless we append to the calls array after the first Promise returns.
			// Like these API calls are happening as they're invoked, instead of as the Promise.all
			// is invoked. Spooky.
			calls.push(OkC.put("/profile/me", {
				data: values,
			}));

			return Promise.all(calls).then((res) => {
				const detailsRes = res.find((result) => !!result.user);

				// sort of lame, but just refresh on change of linked account status
				if (values.linked_account) {
					window.location.reload();
				}

				return detailsRes;
			});
		});
	},

	// username search on our site is a real steaming pile of shit in that it
	// doesn't always return a match, even if the target user 100% absolutely
	// exists. so we're going to shotgun a request to username search to get
	// some results, but also one to profile fields, which isn't such a fucking
	// fuckface.
	usernameSearch(query) {
		if (!exists(query)) {
			return Promise.reject("");
		}

		const requests = [
			OkC.api("/profile/find", {
				api: 1,
				data: {
					query,
				},
			}),
			OkC.api(`/profile/${query}/fields`, {
				api: 1,
				data: {
					fields: [""],
				},
			}),
		];

		return Promise.all(requests).then(([findResults, fieldsResults]) => {
			const results = [];
			const userids = {};

			findResults.data.forEach((user) => {
				if (!userids[user.id]) {
					results.push(user);
				}

				userids[user.id] = user.username;
			});

			if (fieldsResults.userid && !userids[fieldsResults.userid]) {
				results.push({
					id: fieldsResults.userid,
					username: fieldsResults.username,
				});
			}

			return results;
		});
	},

	savePronouns(data = {}) {
		return OkC.post("/profile/me/pronouns", { data });
	},

	searchEducation(query) {
		return OkC.post("/profile/education/search", { data: { query } });
	},
};



// WEBPACK FOOTER //
// ./src/apps/edit_details/util/web.js